import React from 'react';
import { LOCKED_INVESTOR_INVESTMENTS_IMAGE } from '../mockImages';

const LockedInvestorInvestmentsSection = () => (
    <div
        className="structured-investments-table-shell structured-investments-table-shell--locked"
        aria-hidden="true"
    >
        <div className="structured-investments-table-wrapper structured-investments-table-wrapper--locked">
            <img
                src={LOCKED_INVESTOR_INVESTMENTS_IMAGE}
                alt="Locked investor investments preview"
                className="structured-investments-table__preview-image structured-investments-table__preview-image--investor-investments"
            />
        </div>
    </div>
);

export default LockedInvestorInvestmentsSection;
